import readXlsxFile from 'read-excel-file'

export const excelFileToRows = async(file: File): Promise<any[]> => {
  try {
    const rows = await readXlsxFile(file)
    return rows
  } catch (error) {
    console.log(error)
    return null
  }
}